import { ComponentSize } from 'src/tef/components/utils/types';

export const buttonVariants = {
  primary: {
    base: 'bg-primary text-white',
    hover: 'hover:bg-primary-hover',
    active: 'active:bg-primary/90',
    disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
  },
  secondary: {
    base: 'bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-100',
    hover: 'hover:bg-slate-200 dark:hover:bg-slate-700',
    active: 'active:bg-slate-300 dark:active:bg-slate-600',
    disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
  },
  outline: {
    base: 'border border-slate-300 dark:border-slate-600 bg-transparent',
    hover: 'hover:border-slate-400 dark:hover:border-slate-500 hover:bg-slate-50 dark:hover:bg-slate-800',
    active: 'active:bg-slate-100 dark:active:bg-slate-700',
    disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
  },
  ghost: {
    base: 'bg-transparent',
    hover: 'hover:bg-slate-100 dark:hover:bg-slate-800',
    active: 'active:bg-slate-200 dark:active:bg-slate-700',
    disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
  },
  danger: {
    base: 'bg-red-600 text-white',
    hover: 'hover:bg-red-700',
    active: 'active:bg-red-800',
    disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
  },
  nav: {
    base: 'bg-transparent',
    hover: 'hover:bg-slate-100 dark:hover:bg-slate-800',
    active: 'bg-primary/10 dark:bg-primary/20 text-primary',
    disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
  },
};

export const buttonSizes: Record<ComponentSize, { padding: string; text: string; icon: string; gap: string }> = {
  xs: { padding: 'px-2 py-1', text: 'text-xs', icon: 'w-3 h-3', gap: 'gap-1' },
  sm: { padding: 'px-3 py-2', text: 'text-sm', icon: 'w-4 h-4', gap: 'gap-1.5' },
  md: { padding: 'px-4 py-3', text: 'text-base', icon: 'w-5 h-5', gap: 'gap-2' },
  lg: { padding: 'px-6 py-4', text: 'text-lg', icon: 'w-6 h-6', gap: 'gap-2.5' },
  xl: { padding: 'px-8 py-5', text: 'text-xl', icon: 'w-7 h-7', gap: 'gap-3' },
};

export const inputVariants = {
  default: {
    base: 'border border-slate-300 dark:border-slate-600',
    focus: 'focus:ring-2 focus:ring-primary focus:border-primary',
    error: 'border-red-500 focus:ring-red-500',
  },
  withLeftIcon: {
    base: 'pl-10',
  },
  withRightIcon: {
    base: 'pr-10',
  },
  withClearButton: {
    base: 'pr-10',
  },
  withLoading: {
    base: 'pr-10',
  },
};

export const inputSizes: Record<
  ComponentSize,
  { padding: string; text: string; icon: string; iconPadding: string; iconOffset: string }
> = {
  xs: { padding: 'px-2 py-1', text: 'text-xs', icon: 'w-3 h-3', iconPadding: 'pl-7', iconOffset: 'pl-2' },
  sm: { padding: 'px-3 py-2', text: 'text-sm', icon: 'w-4 h-4', iconPadding: 'pl-9', iconOffset: 'pl-3' },
  md: { padding: 'px-4 py-3', text: 'text-base', icon: 'w-5 h-5', iconPadding: 'pl-10', iconOffset: 'pl-3' },
  lg: { padding: 'px-6 py-4', text: 'text-lg', icon: 'w-5 h-5', iconPadding: 'pl-12', iconOffset: 'pl-4' },
  xl: { padding: 'px-8 py-5', text: 'text-xl', icon: 'w-6 h-6', iconPadding: 'pl-14', iconOffset: 'pl-5' },
};
